(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deewhy-discover"] && !Shopify.designMode) return;
  try {
    

function initDiscoverSwipe(root) {
 root.querySelectorAll('.dw-discover__grid').forEach(grid=>{
  if(grid.dataset.swipeReady)return;
  grid.dataset.swipeReady='compositor-v2';
  const mobile=matchMedia('(max-width:749px)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const viewport=document.createElement('div');viewport.className='dw-discover__viewport';
  grid.before(viewport);viewport.appendChild(grid);
  const originals=Array.from(grid.children);
  const copies=originals.map(item=>{
   const copy=item.cloneNode(true);copy.classList.add('dw-discover__copy');copy.setAttribute('aria-hidden','true');
   copy.removeAttribute('data-shopify-editor-block');
   copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
   copy.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);
   grid.appendChild(copy);return copy;
  });
  let animation=null,duration=0,speed=0.030,held=false,dragged=false,startX=0,startTime=0,pressedAt=0,resumeTimer;
  const build=()=>{
   const phase=animation&&duration?Number(animation.currentTime||0)%duration/duration:0;
   if(animation)animation.cancel();animation=null;
   if(!mobile.matches||!copies.length)return;
   const distance=copies[0].offsetLeft-originals[0].offsetLeft;
   if(distance<=0)return;
   speed=reduced.matches?0.015:0.030;duration=distance/speed;
   animation=grid.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d('+(-distance)+'px,0,0)'}],{duration,iterations:Infinity,easing:'linear'});
   animation.currentTime=phase*duration;
   if(held||document.hidden)animation.pause();
  };
  viewport.addEventListener('pointerdown',event=>{
   if(!mobile.matches||event.button>0)return;
   clearTimeout(resumeTimer);held=true;dragged=false;startX=event.clientX;pressedAt=performance.now();
   if(animation){animation.pause();startTime=Number(animation.currentTime||0);}
  });
  viewport.addEventListener('pointermove',event=>{
   if(!held||!animation)return;
   const delta=event.clientX-startX;
   if(!dragged&&Math.abs(delta)<6)return;
   dragged=true;viewport.setPointerCapture(event.pointerId);
   animation.currentTime=((startTime-delta/speed)%duration+duration)%duration;
  });
  const release=()=>{
   if(!held)return;held=false;
   if(performance.now()-pressedAt>450)dragged=true;
   resumeTimer=setTimeout(()=>{if(animation&&!document.hidden)animation.play();},800);
  };
  window.addEventListener('pointerup',release);
  viewport.addEventListener('pointercancel',release);
  viewport.addEventListener('lostpointercapture',release);
  viewport.addEventListener('dragstart',event=>event.preventDefault());
  viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation();dragged=false;}},true);
  viewport.addEventListener('focusin',()=>{if(animation)animation.pause();});
  viewport.addEventListener('focusout',()=>{if(animation&&!held&&!document.hidden)animation.play();});
  document.addEventListener('visibilitychange',()=>{if(animation){if(document.hidden)animation.pause();else if(!held)animation.play();}});
  window.addEventListener('pageshow',()=>{held=false;if(animation)animation.play();else build();});
  mobile.addEventListener('change',build);reduced.addEventListener('change',build);
  new ResizeObserver(build).observe(viewport);
  build();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initDiscoverSwipe(document),{once:true});
else initDiscoverSwipe(document);
document.addEventListener('shopify:section:load',event=>initDiscoverSwipe(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dw-top-brands"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('dw-brand-carousel'))customElements.define('dw-brand-carousel',class extends HTMLElement{
 connectedCallback(){
  this.mobile=matchMedia('(max-width:749px)');
  this.track=this.querySelector('ul');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.hovered=false;this.focused=false;this.touching=false;this.position=this.track.scrollLeft;
  const originals=[...this.track.children];this.originalCount=originals.length;
  originals.forEach(item=>{const copy=item.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.dataset.clone='true';copy.removeAttribute('data-shopify-editor-block');copy.querySelectorAll('a').forEach(a=>a.tabIndex=-1);this.track.append(copy);});
  const measure=()=>{const first=this.track.children[0],repeat=this.track.children[this.originalCount];this.loopWidth=repeat.getBoundingClientRect().left-first.getBoundingClientRect().left;this.position=this.track.scrollLeft;};
  this.resize=new ResizeObserver(measure);this.resize.observe(this.track);measure();
  this.track.addEventListener('mouseenter',()=>this.hovered=true,opts);this.track.addEventListener('mouseleave',()=>{this.hovered=false;this.position=this.track.scrollLeft;},opts);
  this.addEventListener('focusin',()=>this.focused=true,opts);this.addEventListener('focusout',e=>{this.focused=this.contains(e.relatedTarget);this.position=this.track.scrollLeft;},opts);
  this.track.addEventListener('pointerdown',()=>this.touching=true,opts);
  window.addEventListener('pointerup',()=>{this.touching=false;this.resumeAt=performance.now()+2500;},opts);
  window.addEventListener('pointercancel',()=>{this.touching=false;this.resumeAt=performance.now()+2500;},opts);
  this.track.addEventListener('wheel',()=>this.resumeAt=performance.now()+2500,{...opts,passive:true});
  const motion=()=>{this.querySelectorAll('[data-clone]').forEach(e=>e.hidden=this.reduced.matches||this.mobile.matches);this.position=this.track.scrollLeft;};this.reduced.addEventListener('change',motion,opts);motion();this.mobile.addEventListener('change',motion,opts);
  this.observer=new IntersectionObserver(entries=>this.visible=entries[0].isIntersecting);this.observer.observe(this);
  this.last=performance.now();
  const frame=now=>{const dt=Math.min(now-this.last,50);this.last=now;
   if(!this.mobile.matches&&!this.reduced.matches&&!this.hovered&&!this.focused&&!this.touching&&!document.hidden&&this.visible&&now>(this.resumeAt||0)&&this.loopWidth>0){this.position=(this.position+dt*0.024)%this.loopWidth;this.track.scrollLeft=this.position;}else{this.position=this.track.scrollLeft;}
   this.frame=requestAnimationFrame(frame);
  };this.frame=requestAnimationFrame(frame);
 }
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();this.querySelectorAll('[data-clone]').forEach(e=>e.remove());}
});



function initBrandSwipe(root) {
 root.querySelectorAll('.dw-top-brands__track').forEach(grid=>{
  if(grid.dataset.swipeReady)return;
  grid.dataset.swipeReady='compositor-v2';
  const mobile=matchMedia('(max-width:749px)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const viewport=document.createElement('div');viewport.className='dw-brand-auto-viewport';
  grid.before(viewport);viewport.appendChild(grid);
  const originals=Array.from(grid.children).filter(el=>!el.hasAttribute("data-clone"));
  const copies=originals.map(item=>{
   const copy=item.cloneNode(true);copy.classList.add('dw-brand-auto-copy');copy.setAttribute('aria-hidden','true');
   copy.removeAttribute('data-shopify-editor-block');
   copy.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
   copy.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);
   grid.appendChild(copy);return copy;
  });
  let animation=null,duration=0,speed=0.030,held=false,dragged=false,startX=0,startTime=0,pressedAt=0,resumeTimer;
  const build=()=>{
   const phase=animation&&duration?Number(animation.currentTime||0)%duration/duration:0;
   if(animation)animation.cancel();animation=null;
   if(!mobile.matches||!copies.length)return;
   grid.style.setProperty("--dw-brand-width",((viewport.clientWidth-16)/2.2)+"px");
   const distance=copies[0].offsetLeft-originals[0].offsetLeft;
   if(distance<=0)return;
   speed=reduced.matches?0.015:0.030;duration=distance/speed;
   animation=grid.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d('+(-distance)+'px,0,0)'}],{duration,iterations:Infinity,easing:'linear'});
   animation.currentTime=phase*duration;
   if(held||document.hidden)animation.pause();
  };
  viewport.addEventListener('pointerdown',event=>{
   if(!mobile.matches||event.button>0)return;
   clearTimeout(resumeTimer);held=true;dragged=false;startX=event.clientX;pressedAt=performance.now();
   if(animation){animation.pause();startTime=Number(animation.currentTime||0);}
  });
  viewport.addEventListener('pointermove',event=>{
   if(!held||!animation)return;
   const delta=event.clientX-startX;
   if(!dragged&&Math.abs(delta)<6)return;
   dragged=true;viewport.setPointerCapture(event.pointerId);
   animation.currentTime=((startTime-delta/speed)%duration+duration)%duration;
  });
  const release=()=>{
   if(!held)return;held=false;
   if(performance.now()-pressedAt>450)dragged=true;
   resumeTimer=setTimeout(()=>{if(animation&&!document.hidden)animation.play();},800);
  };
  window.addEventListener('pointerup',release);
  viewport.addEventListener('pointercancel',release);
  viewport.addEventListener('lostpointercapture',release);
  viewport.addEventListener('dragstart',event=>event.preventDefault());
  viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation();dragged=false;}},true);
  viewport.addEventListener('focusin',()=>{if(animation)animation.pause();});
  viewport.addEventListener('focusout',()=>{if(animation&&!held&&!document.hidden)animation.play();});
  document.addEventListener('visibilitychange',()=>{if(animation){if(document.hidden)animation.pause();else if(!held)animation.play();}});
  window.addEventListener('pageshow',()=>{held=false;if(animation)animation.play();else build();});
  mobile.addEventListener('change',build);reduced.addEventListener('change',build);
  new ResizeObserver(build).observe(viewport);
  build();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initBrandSwipe(document),{once:true});
else initBrandSwipe(document);
document.addEventListener('shopify:section:load',event=>initBrandSwipe(event.target));



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (document.querySelector('.announcement-bar-section')) {
      this.announce = document.querySelector('.announcement-bar-section');
      this.setAnnounceHeight();
    } 
    else {
      this.withoutAnnounceHeight();
    }
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  setAnnounceHeight() {
    document.documentElement.style.setProperty('--announce-height', `${this.announce.offsetHeight}px`);
  }
  withoutAnnounceHeight() {
    document.documentElement.style.setProperty('--announce-height', `0px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    // this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

// document.addEventListener('DOMContentLoaded', function() {
//       var form = document.querySelector('.search__input');
//       var defaultSearch = document.querySelector('.default--search');

//       if (form && defaultSearch) {
//           form.addEventListener('focusin', function() {
//               defaultSearch.classList.add('focused');
//           });

//           form.addEventListener('focusout', function() {
//               defaultSearch.classList.remove('focused');
//           });
//       }
//   });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');

//     if (form && defaultSearch) {
//         // Add 'focused' class on focus
//         form.addEventListener('focusin', function() {
//             defaultSearch.classList.add('focused');
//         });

//         // Remove 'focused' class on blur
//         form.addEventListener('focusout', function() {
//             defaultSearch.classList.remove('focused');
//         });

//         // Remove 'focused' class on keydown
//         form.addEventListener('keydown', function() {
//             defaultSearch.classList.remove('focused');
//         });
//     }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');
//     var focusHandled = false; // Flag to track if focus events should be handled

//     if (form && defaultSearch) {
//         // Add 'focused' class on focus
//         form.addEventListener('focusin', function() {
//             if (!focusHandled) {
//                 defaultSearch.classList.add('focused');
//             }
//         });

//         // Remove 'focused' class on blur
//         form.addEventListener('focusout', function() {
//             if (!focusHandled) {
//                 defaultSearch.classList.remove('focused');
//             }
//         });

//         // Remove 'focused' class on keydown and stop further focus handling
//         form.addEventListener('keydown', function() {
//             if (!focusHandled) {
//                 defaultSearch.classList.remove('focused');
//                 focusHandled = true; // Stop handling focus events
//             }
//         });
        
//         // Optional: Reset focus handling if input is cleared (if needed)
//         form.addEventListener('input', function() {
//             if (form.value === '') {
//                 focusHandled = false; // Re-enable focus handling if input is empty
//                 defaultSearch.classList.remove('focused');
//             }
//         });
//     }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');
//     var classRemoved = false; // Flag to track if the class has been removed

//     if (form && defaultSearch) {
//         // Function to update the class based on input value
//         function updateFocusClass() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//                 classRemoved = true; // Track that class has been removed
//             } else if (classRemoved) {
//                 defaultSearch.classList.add('focused');
//                 classRemoved = false; // Reset flag if class is re-added
//             }
//         }

//         // Add 'focused' class on focus
//         form.addEventListener('focusin', function() {
//             if (form.value.length === 0 && !classRemoved) {
//                 defaultSearch.classList.add('focused');
//             }
//         });

//         // Remove 'focused' class on blur if there are characters
//         form.addEventListener('focusout', function() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//                 classRemoved = true; // Track that class has been removed
//             }
//         });

//         // Handle keydown and input events
//         form.addEventListener('keydown', function() {
//             updateFocusClass();
//         });

//         form.addEventListener('input', function() {
//             updateFocusClass();
//         });
//     }
// });
// document.addEventListener('DOMContentLoaded', function() {
//     var form = document.querySelector('.search__input');
//     var defaultSearch = document.querySelector('.default--search');
//     var hasCharacters = false; // Flag to track if there are characters in the input field

//     if (form && defaultSearch) {
//         // Function to update the 'focused' class based on input value
//         function updateFocusClass() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//                 hasCharacters = true; // Indicate that there are characters in the input
//             } else if (hasCharacters) {
//                 defaultSearch.classList.add('focused');
//                 hasCharacters = false; // Reset flag if input is empty
//             }
//         }

//         // Add 'focused' class on focus if the input is empty
//         form.addEventListener('focusin', function() {
//             if (form.value.length === 0 && !hasCharacters) {
//                 defaultSearch.classList.add('focused');
//             }
//         });

//         // Remove 'focused' class on blur if there are characters
//         form.addEventListener('focusout', function() {
//             if (form.value.length > 0) {
//                 defaultSearch.classList.remove('focused');
//             }
//         });

//         // Handle keydown and input events to update the focus class dynamically
//         form.addEventListener('keydown', function() {
//             updateFocusClass();
//         });

//         form.addEventListener('input', function() {
//             updateFocusClass();
//         });
//     }
// });
document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('.search__input');
  var defaultSearch = document.querySelector('.default--search');
  var hasCharacters = false;

  if (form && defaultSearch) {
    function updateFocusClass() {
      if (form.value.length > 0) {
        defaultSearch.classList.add('hidden'); 
        hasCharacters = true;
      } else if (hasCharacters) {
        defaultSearch.classList.remove('hidden');
        hasCharacters = false;
      }
    }

    form.addEventListener('focusin', function() {
      if (form.value.length === 0 && !hasCharacters) {
        defaultSearch.classList.remove('hidden');
      }
    });

    form.addEventListener('focusout', function() {
      if (form.value.length > 0) {
        defaultSearch.classList.add('hidden');
      }
    });

    form.addEventListener('keydown', function() {
      updateFocusClass();
    });

    form.addEventListener('input', function() {
      updateFocusClass();
    });
    document.addEventListener('keydown', function(event) {
      if (event.key === "Escape") {
        form.blur();
        defaultSearch.classList.add('hidden');
      }
    });

    document.addEventListener('click', function(event) {
      if (!form.contains(event.target) && !defaultSearch.contains(event.target)) {
        defaultSearch.classList.add('hidden');
        form.blur(); 
      }
    });
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["practitioner-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dw-practitioner-brands')) {
    customElements.define('dw-practitioner-brands', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        const viewport = this.querySelector('.dw-practitioner__viewport');
        viewport.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') this.toggleAttribute('data-paused');
        });
        this.setAttribute('data-ready', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
              class ProductModal extends ModalDialog {
                  constructor() {
                  super();
                  }

                  hide() {
                  super.hide();
                  }

                  show(opener) {
                  super.show(opener);
                  this.showActiveMedia();
                  }

                  showActiveMedia() {
                  this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                      element.classList.remove('active');
                      }
                  )
                  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                  const activeMediaTemplate = activeMedia.querySelector('template');
                  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                  activeMedia.classList.add('active');
                  activeMedia.scrollIntoView();

                  const container = this.querySelector('[role="document"]');
                  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                  if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                      activeMedia.loadContent();
                  }
              }

              customElements.define('product-modal', ProductModal);
              
  } catch(e) { console.error(e); }
})();
})();
